import { routes } from "../routes";

export const isAuthPath = (asPath: string) => {
  return asPath.includes(routes.auth.root) || asPath.includes(routes.verify);
};
